import { FC } from 'react';

const Error403: FC = () => {
  return (
    <>
      <h1 className="fw-bolder fs-2x text-gray-700 mb-10">Yetkisiz Erişim</h1>

      <div className="fw-bold fs-3 text-gray-400 mb-15">
        Bu sayfaya erişim yetkiniz bulunmamaktadır! <br /> Lütfen sistem yöneticiniz ile iletişime geçin.
      </div>
    </>
  );
};

export { Error403 };
